import { c as _c } from "react/compiler-runtime";
import { BackupPolicyType, ResourceType, VaultStorageTier } from '@repo/api-gw-sdk';
import { useCallback, useMemo } from 'react';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';
import { useSupportedResourceTypes } from '@/data/inventory/useSupportedResourceTypes';
import { COLD_TIER_SUPPORTED_RESOURCE_TYPES } from '@/utils/vaultStorageTier';
export type GetBackupPolicyAvailableTypes = (policyType: BackupPolicyType, vaultStorageTier: VaultStorageTier) => ResourceType[];
export function useBackupPolicyAvailableTypes() {
  const $ = _c(63);
  const {
    GcpVmHighFrequencyBackupEnabled,
    RdsHighFrequencyBackupEnabled,
    SapHanaPitrSupport,
    AzureSqlVirtualMachineSupport,
    GcpSqlVirtualMachineSupport,
    EnableBigQueryNativePolicy,
    MongoAtlasSupport,
    AwsRdsNativeBackupSupport,
    AwsEksClusterBackupSupport,
    GoogleWorkspaceSupport,
    Microsoft365Support,
    EntraIdSupport,
    AzureNativeVmBackupSupport,
    AwsEc2InAccountBackupSupport
  } = useFeatureFlags();
  const allTypes = useSupportedResourceTypes();
  let t0;
  if ($[0] !== GcpVmHighFrequencyBackupEnabled) {
    t0 = GcpVmHighFrequencyBackupEnabled ? [ResourceType.GcpComputeEngineInstance] : [];
    $[0] = GcpVmHighFrequencyBackupEnabled;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== RdsHighFrequencyBackupEnabled) {
    t1 = RdsHighFrequencyBackupEnabled ? [ResourceType.AwsRds] : [];
    $[2] = RdsHighFrequencyBackupEnabled;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== MongoAtlasSupport) {
    t2 = MongoAtlasSupport ? [ResourceType.AtlasMongodbCluster] : [];
    $[4] = MongoAtlasSupport;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t0 || $[7] !== t1 || $[8] !== t2) {
    t3 = [ResourceType.AwsEc2, ...t0, ...t1, ResourceType.AwsDynamoDb, ResourceType.AwsKeyspacesTable, ResourceType.AwsS3, ResourceType.GcpCloudStorageBucket, ...t2];
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const HighFrequencySupportedResourceTypes = t3;
  let t4;
  if ($[10] !== AwsEc2InAccountBackupSupport) {
    t4 = [...(AwsEc2InAccountBackupSupport ? [ResourceType.AwsEc2] : [])];
    $[10] = AwsEc2InAccountBackupSupport;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const awsNativeHighFrequencySupportedResourceTypes = t4;
  let t5;
  if ($[12] !== AzureSqlVirtualMachineSupport) {
    t5 = AzureSqlVirtualMachineSupport ? [ResourceType.AzureSqlVirtualMachine] : [];
    $[12] = AzureSqlVirtualMachineSupport;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== GcpSqlVirtualMachineSupport) {
    t6 = GcpSqlVirtualMachineSupport ? [ResourceType.GcpSqlVm] : [];
    $[14] = GcpSqlVirtualMachineSupport;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== SapHanaPitrSupport) {
    t7 = SapHanaPitrSupport ? [ResourceType.AzureSapHanaVm, ResourceType.GcpSapHanaVm] : [];
    $[16] = SapHanaPitrSupport;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
    t8 = [...t5, ...t6, ...t7];
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const pitrPolicySupportedResourceTypes = t8;
  let t9;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = [ResourceType.AwsRds];
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const nativePitrPolicySupportedResourceTypes = t9;
  let t10;
  if ($[23] !== EnableBigQueryNativePolicy) {
    t10 = [...(EnableBigQueryNativePolicy ? [ResourceType.GcpBigQuery] : [])];
    $[23] = EnableBigQueryNativePolicy;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  const bigQueryNativePitrSupportedResourceTypes = t10;
  let t11;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = [ResourceType.AzureSqlDatabase];
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const azureSqlDatabaseNativePitrSupportedResourceTypes = t11;
  let t12;
  if ($[26] !== AwsRdsNativeBackupSupport) {
    t12 = AwsRdsNativeBackupSupport ? [ResourceType.AwsRds] : [];
    $[26] = AwsRdsNativeBackupSupport;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== AwsEksClusterBackupSupport) {
    t13 = AwsEksClusterBackupSupport ? [ResourceType.AwsEksCluster] : [];
    $[28] = AwsEksClusterBackupSupport;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t12 || $[31] !== t13) {
    t14 = [ResourceType.AwsFsx, ResourceType.AwsEfs, ResourceType.AwsDocumentdb, ResourceType.AwsNeptune, ...t12, ...t13];
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  const awsNativeStandardPolicySupportedResourceTypes = t14;
  let t15;
  if ($[33] !== AzureNativeVmBackupSupport) {
    t15 = [ResourceType.AzureFileShare, ...(AzureNativeVmBackupSupport ? [ResourceType.AzureVirtualMachine] : [])];
    $[33] = AzureNativeVmBackupSupport;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  const azureFilesPolicySupportedResourceTypes = t15;
  let t16;
  if ($[35] !== GoogleWorkspaceSupport) {
    t16 = [...(GoogleWorkspaceSupport ? [ResourceType.GoogleWorkspaceResource] : [])];
    $[35] = GoogleWorkspaceSupport;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  const googleWorkspacePolicySupportedResourceTypes = t16;
  let t17;
  if ($[37] !== Microsoft365Support) {
    t17 = [...(Microsoft365Support ? [ResourceType.Microsoft365Resource] : [])];
    $[37] = Microsoft365Support;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  const microsoft365PolicySupportedResourceTypes = t17;
  let t18;
  if ($[39] !== EntraIdSupport) {
    t18 = [...(EntraIdSupport ? [ResourceType.AzureEntraIdResource] : [])];
    $[39] = EntraIdSupport;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  const entraIdPolicySupportedResourceTypes = t18;
  let t19;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = [ResourceType.AwsRds, ResourceType.AzureVirtualMachine];
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  const dualSupportedResourceTypes = t19;
  let t20;
  if ($[42] !== allTypes || $[43] !== awsNativeStandardPolicySupportedResourceTypes || $[44] !== azureFilesPolicySupportedResourceTypes) {
    let t21;
    if ($[46] !== awsNativeStandardPolicySupportedResourceTypes || $[47] !== azureFilesPolicySupportedResourceTypes) {
      t21 = type => (!awsNativeStandardPolicySupportedResourceTypes.includes(type) || dualSupportedResourceTypes.includes(type)) && (!azureFilesPolicySupportedResourceTypes.includes(type) || dualSupportedResourceTypes.includes(type)) && type !== ResourceType.GoogleWorkspaceResource && type !== ResourceType.Microsoft365Resource && type !== ResourceType.AzureEntraIdResource;
      $[46] = awsNativeStandardPolicySupportedResourceTypes;
      $[47] = azureFilesPolicySupportedResourceTypes;
      $[48] = t21;
    } else {
      t21 = $[48];
    }
    t20 = [...allTypes.filter(t21)];
    $[42] = allTypes;
    $[43] = awsNativeStandardPolicySupportedResourceTypes;
    $[44] = azureFilesPolicySupportedResourceTypes;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  const standardPolicySupportedResourceTypes = t20;
  let t21;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = [];
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] !== HighFrequencySupportedResourceTypes || $[51] !== awsNativeHighFrequencySupportedResourceTypes || $[52] !== awsNativeStandardPolicySupportedResourceTypes || $[53] !== azureFilesPolicySupportedResourceTypes || $[54] !== bigQueryNativePitrSupportedResourceTypes || $[55] !== entraIdPolicySupportedResourceTypes || $[56] !== googleWorkspacePolicySupportedResourceTypes || $[57] !== microsoft365PolicySupportedResourceTypes || $[58] !== pitrPolicySupportedResourceTypes || $[59] !== standardPolicySupportedResourceTypes) {
    t22 = {
      [BackupPolicyType.BACKUP_POLICY_TYPE_HIGH_FREQUENCY]: HighFrequencySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AWS_NATIVE_HIGH_FREQUENCY]: awsNativeHighFrequencySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_PITR]: pitrPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AWS_NATIVE_PITR]: nativePitrPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_STANDARD]: standardPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AWS_NATIVE_STANDARD]: awsNativeStandardPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_BIGQUERY_NATIVE_PITR]: bigQueryNativePitrSupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AZURE_SQL_DATABASE_NATIVE_PITR]: azureSqlDatabaseNativePitrSupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AZURE_FILES]: azureFilesPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_GOOGLE_WORKSPACE]: googleWorkspacePolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_MICROSOFT_365]: microsoft365PolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AZURE_ENTRA_ID]: entraIdPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_UNSPECIFIED]: t21
    };
    $[50] = HighFrequencySupportedResourceTypes;
    $[51] = awsNativeHighFrequencySupportedResourceTypes;
    $[52] = awsNativeStandardPolicySupportedResourceTypes;
    $[53] = azureFilesPolicySupportedResourceTypes;
    $[54] = bigQueryNativePitrSupportedResourceTypes;
    $[55] = entraIdPolicySupportedResourceTypes;
    $[56] = googleWorkspacePolicySupportedResourceTypes;
    $[57] = microsoft365PolicySupportedResourceTypes;
    $[58] = pitrPolicySupportedResourceTypes;
    $[59] = standardPolicySupportedResourceTypes;
    $[60] = t22;
  } else {
    t22 = $[60];
  }
  const supportedResourceTypes = t22;
  const policySupportedResourceTypes = supportedResourceTypes;
  let t23;
  if ($[61] !== policySupportedResourceTypes) {
    t23 = (policyType, vaultStorageTier) => {
      const availableTypes = policySupportedResourceTypes[policyType];
      return vaultStorageTier === VaultStorageTier.VAULT_STORAGE_TIER_COLD ? availableTypes.filter(_temp) : availableTypes;
    };
    $[61] = policySupportedResourceTypes;
    $[62] = t23;
  } else {
    t23 = $[62];
  }
  return t23;
}
function _temp(resourceType) {
  return COLD_TIER_SUPPORTED_RESOURCE_TYPES.includes(resourceType);
}